import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
// Default implementation of generic store interface.
// Uses localStorage or sessionStorage (pass which one you want in constructor).
export var LocalStorageStore = /*#__PURE__*/function () {
  function LocalStorageStore() {
    var storage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : localStorage;

    _classCallCheck(this, LocalStorageStore);

    this.storage = storage;
  }

  _createClass(LocalStorageStore, [{
    key: "clear",
    value: function clear() {
      this.storage.clear();
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.storage.getItem(key);
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      this.storage.setItem(key, value);
    }
  }, {
    key: "clearItem",
    value: function clearItem(key) {
      this.storage.removeItem(key);
    }
  }]);

  return LocalStorageStore;
}();